/* eslint max-len: off *//* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Chrome = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M2.898 4.18C8.476-2.311 18.82-1.03 22.686 6.555h-9.293c-1.674 0-2.755-.038-3.926.579-1.376.724-2.414 2.067-2.777 3.644L2.898 4.181zM8.008 12c0-2.2 1.789-3.99 3.988-3.99A3.994 3.994 0 0 1 15.984 12c0 2.2-1.789 3.99-3.988 3.99-2.2 0-3.988-1.79-3.988-3.99zm5.536 5.223l-3.87 6.551C1.31 22.132-2.662 12.51 1.945 5.45c1.315 2.292 4.21 7.334 5.305 9.224 1.435 2.477 4.054 3.215 6.293 2.55zM15.7 8.009h7.609c2.837 8.053-3.445 16.498-12.062 15.967 1.472-2.482 4.509-7.607 5.46-9.248a5.464 5.464 0 0 0-1.007-6.719z"
    />
  </Icon>
);
